module.exports = __webpack_public_path__ + "static/img/tabela.c40ee8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tubaina-retro/tabela.png
// module id = 0Ydj
// module chunks = 0